import {useEffect, useState} from 'react';
import {useFetchRushDailyHighScoresQuery} from '@api';

export const useRushDailyHighScores = () => {
    const query = useFetchRushDailyHighScoresQuery();
    const {data, refetch} = query;
    const [dayExpired, setDayExpired] = useState(false);

    useEffect(() => {
        if (!data?.resetsAt) return;
        const delay = Date.parse(data.resetsAt) - Date.now();
        setDayExpired(delay <= 0);
        // Do not keep yesterday's winners on screen across the site's midnight.
        const timer = window.setTimeout(
            () => {
                setDayExpired(true);
                void refetch();
            },
            Math.max(0, delay + 1000)
        );
        return () => window.clearTimeout(timer);
    }, [data?.resetsAt, refetch]);

    return {...query, isLoading: query.isLoading || dayExpired};
};
